/**
 *
 * ActionsWrapper
 *
 * @author: Matthew Rawson @ 15/08/2018 12:18
 * @description:
 * @notes:
 */
import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"

export default styled.div`
  display: flex;
  justify-content: flex-end;
  ${({marginRight}) => marginRight && `margin-right:${padding.tiny}`};
`
